import { createSlice } from "@reduxjs/toolkit";
import GnlOrganizasyonDTO from "src/models/Settings/Generals/GnlOrganizasyonDTO";
import VwGnlOrganizasyonEntegreDTO from "src/models/Settings/Generals/VwGnlOrganizasyonEntegreDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

interface IOrganizasyonTanim {
    activeRow?: GnlOrganizasyonDTO;
    ekleOpen?: boolean;
    odemeTipOpen?: boolean;
    entegrasyonOpen?: boolean;
    entegrasyonEkleOpen?: boolean;
    entegrasyonActiveRow?: VwGnlOrganizasyonEntegreDTO;
};

const OrganizasyonTanimSlice = createSlice<IOrganizasyonTanim, MapReducerPayloads<IOrganizasyonTanim, {
    setActiveRow?: GnlOrganizasyonDTO;
    setEkleOpen?: boolean;
    setOdemeTipOpen?: boolean;
    setEntegrasyonOpen?: boolean;
    setEntegrasyonEkleOpen?: boolean;
    setEntegrasyonActiveRow?: VwGnlOrganizasyonEntegreDTO;
}>>({
    name: "OrganizasyonTanimState",
    initialState: {
        activeRow: new GnlOrganizasyonDTO(),
        ekleOpen: false,
        odemeTipOpen: false,
        entegrasyonOpen: false,
        entegrasyonEkleOpen: false,
        entegrasyonActiveRow: new VwGnlOrganizasyonEntegreDTO(),
    },
    reducers: {
        setActiveRow: (state, action) => {
            state.activeRow = action.payload
        },
        setEkleOpen: (state, action) => {
            state.ekleOpen = action.payload
        },
        setOdemeTipOpen: (state, action) => {
            state.odemeTipOpen = action.payload
        },
        setEntegrasyonOpen: (state, action) => {
            state.entegrasyonOpen = action.payload
        },
        setEntegrasyonEkleOpen: (state, action) => {
            state.entegrasyonEkleOpen = action.payload
        },
        setEntegrasyonActiveRow: (state, action) => {
            state.entegrasyonActiveRow = action.payload
        },
    }
});

export default OrganizasyonTanimSlice;